import { render, staticRenderFns } from "./squads.vue?vue&type=template&id=216fe8cb&scoped=true&"
import script from "./squads.js?vue&type=script&lang=js&"
export * from "./squads.js?vue&type=script&lang=js&"
import style0 from "./squads.vue?vue&type=style&index=0&id=216fe8cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216fe8cb",
  null
  
)

export default component.exports